import React, { useEffect, useRef, useState } from 'react';

// Service Worker の更新を検知したときに src/index.js から発火するイベント名。
export const SW_UPDATE_EVENT = 'uronote:sw-updated';

// 新しいバージョンを検知したことを知らせる控えめなバナー。
// 勝手にリロードはしない。ManualInput / Camera に入力途中の状態があるため、
// ユーザーが「更新する」を押したときにだけ切り替える。
const SwUpdateNotification = props => {

  const [waitingWorker, setWaitingWorker] = useState(null);
  const [isDismissed, setIsDismissed] = useState(false);

  // 「更新する」の二度押しと、リロードの多重実行を防ぐ。
  const isReloadingRef = useRef(false);

  useEffect(() => {

    const handleSwUpdated = event => {
      const registration = event.detail;
      if (!registration) {
        return;
      }
      if (!registration.waiting) {
        return;
      }
      setWaitingWorker(registration.waiting);
      setIsDismissed(false);
    };

    window.addEventListener(SW_UPDATE_EVENT, handleSwUpdated);

    // このコンポーネントがマウントされる前に更新が検知されていた場合の取りこぼしを防ぐ。
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration()
        .then(registration => {
          if (!registration) {
            return;
          }
          if (!registration.waiting) {
            return;
          }
          setWaitingWorker(registration.waiting);
        })
        .catch(() => {
          // 取得できない場合は通知を出さないだけなので、ここでは何もしない。
        });
    }

    return () => {
      window.removeEventListener(SW_UPDATE_EVENT, handleSwUpdated);
    };
  }, []);

  // 待機中の Service Worker に切り替えてからリロードする。
  const applyUpdate = () => {

    if (!waitingWorker) {
      return;
    }
    if (isReloadingRef.current) {
      return;
    }
    isReloadingRef.current = true;

    // 新しい Service Worker が制御を取ったタイミングでリロードする。
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      window.location.reload();
    }, { once: true });

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  };

  if (!waitingWorker) {
    return null;
  }
  if (isDismissed) {
    return null;
  }

  return (
    <div className="p-sw-update">
      <p className="p-sw-update__txt">
        新しいバージョンがあります
      </p>
      <div className="p-sw-update__btns">
        <button
          type="button"
          className="c-btn p-sw-update__btn p-sw-update__btn-later"
          onClick={() => {
            setIsDismissed(true);
          }}
        >
          あとで
        </button>
        <button
          type="button"
          className="c-btn p-sw-update__btn p-sw-update__btn-apply"
          onClick={applyUpdate}
        >
          更新する
        </button>
      </div>
    </div>
  );
}

export default SwUpdateNotification;
